import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import DataTable from "react-data-table-component";

/* MATERIAL TAILWIND COMPONENTS */
import {
  Button,
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
  Tooltip,
} from "@material-tailwind/react";

/* ICONS */
import { IoIosArrowForward } from "react-icons/io";
import { FaClipboardUser } from "react-icons/fa6";
import { IoCart, IoPrint, IoEyeSharp } from "react-icons/io5";

/* USER DEFINED COMPONENTS */
import Input from "../../../components/input";

/* SAMPLE DATA */

import OrdersComponent from "../../../components/customers/orders";
import InvoiceComponent from "../../../components/customers/invoice";
import { SET_FORMAT } from "../../../config";
import { handleAddToken } from "../../../service/request";
import { useSelector } from "react-redux";

import { getUsersList } from "../../../service/api/user.api";


/* TILES */
const tilesOptions = [
  { id: 1, value: "Personal Details", icon: FaClipboardUser },
  { id: 2, value: "Previous Orders", icon: IoCart },
  // { id: 3, value: "Invoices", icon: IoPrint },
];

const Customers = () => {
    // GLOBAL VARIALBES
    const userDetails = useSelector((state) => state?.user);
  // STATE VARIABLES
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [usersList, setUsersList] = useState([]);
  const [totalDocs, setTotalDocs] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  const [selectedUser, setSelectedUser] = useState(null);

  const [invoiceAmount, setTotalInvoiceAmount] = useState(0);

  const [activeTile, setActiveTile] = useState("Personal Details");

  // Functions
  const usersGetFunction = async () => {
    const obj = {
      page,
      sizePerPage,
      pagination: true,
    };
    if (search) {
      obj.search = search;
    }
    if (selectedStatus) {
      obj.status = selectedStatus?.value;
    }
    await handleAddToken(userDetails?.token);
    setLoading(true);
    getUsersList(obj)
      .then((response) => {
        if (response?.status) {
          console.log("response", response);
          setUsersList(response?.data?.docs);
          setTotalDocs(response?.data?.totalDocs);
          setTotalPages(response?.data?.totalPages);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  /* GET INITIALS */
  const getInitials = (name) => {
    var parts = name.split(" ");
    var initials = "";
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].length > 0 && parts[i] !== "") {
        initials += parts[i][0];
      }
    }
    return initials;
  };

  /* INVOICE TILE */
  const InvoiceTile = (props) => {
    return (
      <div>
        <h5 className="text-base font-proxima-regular text-greyText">
          Total Invoice Amount
        </h5>
        <h2 className="text-2xl font-proxima-semibold text-logoYellow">
          {props.amount}{" "}
          <span className="text-base font-proxima-semibold text-logoYellow">
            INR
          </span>
        </h2>
      </div>
    );
  };

  /* PROFILE TILES */
  const ProfileTile = (props) => {
    return (
      <div
        className={`${activeTile !== props.tileName &&
          "group"} flex items-center justify-between px-3 py-4 cursor-pointer mt-2 first:mt-0 ${activeTile ===
          props.tileName &&
          "bg-black bg-opacity-5"} rounded-md transition-all duration-300 ease-in-out`}
        onClick={() => setActiveTile(props.tileName)}
      >
        <div className="flex items-center gap-2">
          <props.icon className="w-5 h-5 text-greyText group-hover:text-logoYellow transition-all duration-300 ease-in-out" />
          <p className="text-sm font-proxima-semibold text-black group-hover:text-logoYellow leading-none transition-all duration-300 ease-in-out">
            {props.tileName}
          </p>
        </div>
        <IoIosArrowForward className="w-4 h-4 text-greyText group-hover:text-logoYellow transition-all duration-300 ease-in-out" />
      </div>
    );
  };

  /* PERSONAL INFORMATION */
  const PersonalInformation = (props) => {
    return (
      <div className="p-5 xl:p-10 lg:p-10">
        <h2 className="text-xl font-proxima-bold text-black">
          Personal Information
        </h2>
        <h3 className="text-base font-proxima-regular text-greyText">
          Basic information, like name, email and phone of Wholesale Ecommerce
          customers
        </h3>
        <div className="mt-5 xl:mt-10 lg:mt-10">
          <div className="bg-greyBg rounded-md w-full py-2 px-5">
            <p className="text-sm font-proxima-semibold text-greyText">
              Basic Information
            </p>
          </div>
          <div className="grid grid-cols-2 border-b border-authBorder px-0 py-5 xl:p-5 lg:p-5">
            <div className="col-span-1">
              <p className="text-base font-proxima-regular text-greyText">
                Name
              </p>
            </div>
            <div className="col-span-1">
              <p className="text-base font-proxima-bold text-black">
                {props.name}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 border-b border-authBorder px-0 py-5 xl:p-5 lg:p-5">
            <div className="col-span-1">
              <p className="text-base font-proxima-regular text-greyText">
                Email address
              </p>
            </div>
            <div className="col-span-1">
              <p
                className="text-base font-proxima-bold text-black"
                style={{ overflowWrap: "anywhere" }}
              >
                {props.email}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 px-0 py-5 xl:p-5 lg:p-5">
            <div className="col-span-1">
              <p className="text-base font-proxima-regular text-greyText">
                Phone number
              </p>
            </div>
            <div className="col-span-1">
              <p className="text-base font-proxima-bold text-black">
                {props.phone}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* USE-EFFECTS */
  useEffect(() => {
    usersGetFunction();
  }, [page, sizePerPage, selectedStatus, search]);

  useEffect(() => {
    if (usersList) {
      setSelectedUser(usersList?.[0]);
    }
  }, [usersList]);

  return (
    <section className="px-0 py-2 xl:p-10 lg:p-10 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Customers | CIDA Perfumes</title>
      </Helmet>

      <div className="container-full-width">
        <div className="block xl:flex lg:flex items-center justify-between">
          {/* HEADING */}
          <div>
            <h1 className="text-3xl font-proxima-bold text-black tracking-tight">
            CIDA Perfumes Customers
            </h1>
            <h2 className="text-lg font-proxima-regular text-greyText tracking-tight">
              Manage the customers who have created the account on your website
            </h2>
          </div>

          {/* SEARCH AND FILTERS */}
          <div className="mt-2 xl:mt-0 lg:mt-0">
            {/* SEARCHBAR */}
            <div className="w-full xl:w-searchBar lg:w-searchBar">
              <Input
                type="text"
                placeholder="Search by customer"
                name="searchCustomer"
                id="searchCustomer"
              />
            </div>
          </div>
        </div>

        {/* CUSTOMERS LIST */}
        <div className="mt-5 xl:mt-10 lg:mt-10">
          <Tabs
            value={selectedUser?._id}
            orientation="vertical"
            className="w-full block overflow-visible"
          >
            <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-y-5 xl:gap-5 lg:gap-5">
              {/* CUSTOMERS LIST */}
              <div className="col-span-1">
                <div className="max-h-customerList bg-white border border-authBorder rounded-md p-3 overflow-y-auto overflow-x-hidden hide-scrollbar">
                  <TabsHeader
                    className="rounded-md bg-transparent p-0"
                    indicatorProps={{
                      className:
                        "border border-logoYellow bg-logoYellow bg-opacity-10",
                    }}
                  >
                    {usersList?.map((data) => (
                      <Tab
                        value={data._id}
                        className="flex items-center justify-between detail-tab p-3 w-full mt-2 first:mt-0"
                        key={data.id}
                        onClick={() => {
                          setSelectedUser(data);
                          setActiveTile(tilesOptions?.[0]?.value);
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <div className="w-10 h-10 bg-logoYellow rounded-full flex items-center justify-center">
                            <p className="text-sm font-proxima-bold text-white leading-none">
                              {getInitials(
                                data?.firstName + " " + data?.lastName
                              )}
                            </p>
                          </div>
                          <div>
                            <h5 className="text-base font-proxima-semibold text-black leading-tight">
                              {data?.firstName + " " + data?.lastName}
                            </h5>
                            <p className="text-sm font-proxima-regular text-greyText">
                              {data?.email}
                            </p>
                          </div>
                        </div>
                        <IoIosArrowForward className="w-4 h-4 text-greyText" />
                      </Tab>
                    ))}
                  </TabsHeader>
                </div>
              </div>

              {/* CUSTOMER DETAIL SECTION */}
              <div className="col-span-3">
                <TabsBody className="p-0">
                  <TabPanel value={selectedUser?._id} className="p-0">
                    <div className="h-customerList max-h-[68vh] bg-white border border-authBorder rounded-md overflow-y-auto overflow-x-hidden hide-scrollbar">
                      <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 h-full">
                        <div className="col-span-1 h-full">
                          <div className="border-r border-authBorder h-full">
                            {/* INVOICE TILE */}
                            <div className="border-b border-authBorder px-7 py-3">
                              <InvoiceTile amount={SET_FORMAT(invoiceAmount)} />
                            </div>

                            {/* TILES */}
                            <div className="p-5">
                              {tilesOptions.map((tile) => (
                                <React.Fragment key={tile.id}>
                                  <ProfileTile
                                    tileName={tile.value}
                                    icon={tile.icon}
                                  />
                                </React.Fragment>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="col-span-2 h-full">
                          {activeTile === "Personal Details" && (
                            <PersonalInformation
                              name={
                                selectedUser?.firstName +
                                " " +
                                selectedUser?.lastName
                              }
                              email={selectedUser?.email}
                              phone={
                                selectedUser?.phoneNumber
                                  ? selectedUser?.phoneNumber
                                  : "-"
                              }
                            />
                          )}
                          {activeTile === "Previous Orders" && (
                            <OrdersComponent userId={selectedUser?._id} />
                          )}
                          {activeTile === "Invoices" && (
                            <InvoiceComponent userId={selectedUser?._id} />
                          )}
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </TabsBody>
              </div>
            </div>
          </Tabs>
        </div>
      </div>
    </section>
  );
};

export default Customers;
